import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import type { TypeCStandardCheckTaskState } from '../utils/typeCStandardCheckTaskState'
import { TypeCStandardCheckProgress } from './TypeCStandardCheckProgress'

type OnboardingTypeCStandardCheckDiscoveryStepProps = {
  typeCStandardCheckTaskState: TypeCStandardCheckTaskState
  typeCStandardCheckError: string | null
  onCancel: () => void
}

export function OnboardingTypeCStandardCheckDiscoveryStep({
  typeCStandardCheckTaskState,
  typeCStandardCheckError,
  onCancel,
}: OnboardingTypeCStandardCheckDiscoveryStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const { data: session } = useGetUserSession()
  const showAdminCancel = session?.isArtemAdmin === true

  return (
    <>
      <div className='w-full max-w-lg space-y-4'>
        <h2 className='text-lg font-semibold tracking-tight'>
          {t('onboarding.typeCStandardCheckDiscovery.heading')}
        </h2>
        <TypeCStandardCheckProgress state={typeCStandardCheckTaskState} />
        {showAdminCancel && (
          <Button type='button' variant='outline' size='sm' onClick={onCancel}>
            {t('onboarding.adminCancelWorkflow')}
          </Button>
        )}
      </div>
      {typeCStandardCheckError && (
        <p className='mt-8 text-center text-sm text-destructive' role='alert'>
          {typeCStandardCheckError}
        </p>
      )}
    </>
  )
}
